import bulkOrders from "./bulkOrders/state";

export default {
  ...bulkOrders,
};
